<template>
    <div class="tour_book">
        <div class="enquiry_title">{{ $t('tour_booking_title') }}</div>
        <el-form class="enquiry_main demo-form-inline" ref="dataForm" :rules="rules" :model="temp">
            <div class="data-g">
                <div>
                    <p>{{ $t('tour_date') }}</p>
                    <p>{{ options.rentDate }}</p>
                </div>
                <div>
                    <p>{{ $t('tour_time') }}</p>
                    <p>
                        {{ ` ${options.statusName}   ${options.startTime}-${options.endTime}` }}
                    </p>
                </div>
            </div>
            <div class="mumber">
                <el-form-item :label="this.$t('Adults')" class="enquiry_main_adults">
                    <el-select
                        v-model="temp.adults"
                        placeholder="0"
                        :popper-append-to-body="false"
                        popper-class="optionsContents"
                    >
                        <el-option v-for="(item, i) in 45" :key="i" :value="i + 1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="this.$t('children')" class="enquiry_main_adults enquiry_main_child-tour">
                    <el-select
                        v-model="temp.child"
                        placeholder="0"
                        :popper-append-to-body="false"
                        popper-class="optionsContents"
                    >
                        <el-option v-for="(item, i) in 6" :key="i" :value="i"></el-option>
                    </el-select>
                </el-form-item>
            </div>

            <el-form-item :label="this.$t('your_name')">
                <el-input v-model="temp.name"></el-input>
            </el-form-item>
            <div class="code-phone">
                <el-form-item :label="$t('intl_code')" class="enquiry_main_code office-number">
                    <el-select
                        v-model="temp.qz"
                        placeholder=""
                        :popper-append-to-body="false"
                        popper-class="optionsContents"
                    >
                        <el-option
                            v-for="(item, i) in areaCode"
                            :key="i"
                            :value="item.phone_code"
                            :label="' +' + item.phone_code"
                            >{{ $i18n.locale == 'chinese' ? item.chinese_name : item.english_name }} +{{
                                item.phone_code
                            }}</el-option
                        >
                    </el-select>
                </el-form-item>
                <el-form-item :label="this.$t('mobile_number')" class="enquiry_main_number">
                    <el-input v-model="temp.mobile"></el-input>
                </el-form-item>
            </div>

            <el-form-item :label="this.$t('e_mail')">
                <el-input v-model="temp.email"></el-input>
            </el-form-item>
            <el-form-item :label="this.$t('total_cost')">
                <el-input v-model="temp.cost" readonly></el-input>
            </el-form-item>
            <div class="form-btn">
                <el-button class="tour_book_close" @click="close()">{{ $t('close') }}</el-button>
                <el-button class="tour_book_sub" @click="commit">{{ $t('checkout_btn') }}</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import AreaCode from '@/utils/phone.json'
import { check_Mail, check_Number, SortAreaCode } from '@/libs/form'
export default {
    props: {
        options: {
            type: Object,
            default: () => {
                return {
                    startTime: '',
                    endTime: '',
                    rentDate: '',
                }
            },
        },
        tour_book: {
            type: Boolean,
        },
    },
    data() {
        return {
            rules: {},
            temp: {
                date: '',
                tour_time: '',
                adults: '',
                child: '',
                infants: '',
                cost: 0,
                name: '',
                qz: '',
                mobile: '',
                email: '',
            },
            times: [
                {
                    name: 'EARLY RISERS',
                    time: '0900',
                    img: '',
                },
                {
                    name: 'AFTER NOON',
                    time: '1100',
                    img: '',
                },
                {
                    name: 'AFTER NOON',
                    time: '1200',
                    img: '',
                },
            ],
            areaCode: AreaCode.sort(SortAreaCode),
            adults: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            childs: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            infants: [0, 1, 2, 3, 4, 5, 6],
            commitStatus: false,
        }
    },
    methods: {
        tour_submit() {
            this.temp.date = this.temp.date / 1000
            this.$emit('tour_submit', this.temp)
        },
        close() {
            this.$emit('close_submit', '')
            this.$set(this.temp, 'cost', 0)
        },
        reset() {
            this.temp = {
                date: '',
                tour_time: '',
                adults: '',
                child: '',
                infants: '',
                cost: 0,
                name: '',
                qz: '',
                mobile: '',
                email: '',
            }
        },
        // 发送计算金额请求
        async calcYachtOrderTotal() {
            const options = this.options
            const { productId, takeOrderType, rentType, rentDate, rentTimeDetailId } = this.options
            let params = {
                productId,
                adultNum: this.temp.adults ? +this.temp.adults : 0,
                childNum: this.temp.child ? +this.temp.child : 0,
                takeOrderType,
                rentType,
                rentDate,
                rentTimeDetailId,
            }
            await this.$store.dispatch('order/calcYachtOrderTotal', params)
            this.$set(this.temp, 'cost', this.$store.state.order.calcYachtOrderTotal.total)
        },
        /**
         * 提交散拼游艇表单
         */
        commit() {
            let { adults, child, name, mobile, email, qz } = this.temp
            if (adults === '' || adults == 0 || !check_Number(adults)) {
                return this.$message.warning(this.$t('form.adultsCheck'))
            }
            if (child === '') {
                child = 0
                this.child = 0
            }
            if (+adults + +child > this.maxNum) {
                return this.$message.warning(this.$t('form.peoplesCheck') + ' ' + this.maxNum)
            }
            if (!check_Number(child)) {
                return this.$message.warning(this.$t('form.childrenCheck'))
            }
            if (name === '' || name.length > 64) {
                return this.$message.warning(this.$t('form.nameCheck'))
            }
            if (qz === '') {
                return this.$message.warning(this.$t('form.qzCheck'))
            }
            if (
                mobile == '' ||
                mobile.length + qz.length > 20 ||
                mobile.length + qz.length < 6 ||
                !check_Number(mobile)
            ) {
                return this.$message.warning(this.$t('form.phoneCheck'))
            }
            if (email === '' || !check_Mail(email)) {
                return this.$message.warning(this.$t('form.emailCheck'))
            }
            if (this.commitStatus) return
            this.commitStatus = true
            // 发送创建订单请求
            let orderMemberInfoCmds = []
            for (let i = 1; i <= +adults; i++) {
                orderMemberInfoCmds.push({
                    memberName: 'Unknown Name',
                    memberType: 1,
                    memberState: 0,
                })
            }

            for (let i = 1; i <= +child; i++) {
                orderMemberInfoCmds.push({
                    memberName: 'Unknown Name',
                    memberType: 2,
                    memberState: 0,
                })
            }
            let params = {
                productId: this.options.productId,
                realName: name,
                mobileNum: qz + '-' + mobile,
                email,
                adultNum: +adults,
                childNum: +child,
                takeOrderType: this.options.takeOrderType,
                rentType: this.options.rentType,
                rentDate: this.options.rentDate,
                rentTimeDetailId: this.options.rentTimeDetailId,
                orderMemberInfoCmds: JSON.stringify(orderMemberInfoCmds),
            }

            this.$store
                .dispatch('order/addYachtsOrder', params)
                .then(() => {
                    this.commitStatus = false
                    this.$emit('tour_submit', this.temp)
                })
                .catch(() => {
                    this.commitStatus = false
                })
        },
    },
    computed: {
        adultsW() {
            return this.temp.adults
        },
        childW() {
            return this.temp.child
        },
    },
    watch: {
        adultsW() {
            this.calcYachtOrderTotal()
        },
        childW() {
            this.calcYachtOrderTotal()
        },
        tour_book() {
            if (!this.tour_book) {
                this.reset()
            }
        },
    },
}
</script>
<style lang="less" scoped>
.office-number {
    /deep/.el-select__caret {
        display: flex;
        justify-content: center;
    }
    /deep/.el-icon-arrow-up::before {
        height: 100%;
        display: flex;
        align-items: center;
    }
    /deep/.el-select-dropdown__item {
        font-family: 'Lato Bold Italic' !important;
    }
}
.data-g {
    display: flex;
    margin-bottom: 26px;
    & > div:first-child {
        width: 120px;
        margin-right: 27px;
    }
    & > div {
        & > p:first-child {
            margin-bottom: 10px;
        }
        & > p:last-child {
            background: #f7f7f7;
            box-shadow: inset 0px 0px 1px 0px rgb(0 0 0 / 16%);
            border-radius: 5px;
            line-height: 26px;
            border: 1px solid #dcdfe6;
            width: 100%;
            padding-left: 12px;
            box-sizing: border-box;
        }
        p {
            font-family: SegoeUI-Bold;
            font-size: 14px;
            color: #172a88;
            font-weight: bold;
        }
    }
    & > div:last-child {
        flex: 1;
    }
}
/deep/.enquiry_main .enquiry_main_code .el-input__inner {
    width: 85px !important;
}
</style>
<style lang="scss" scoped>
@import '@/styles/class.scss';
::v-deep.tour_book {
    width: 466px;
    height: 789px;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    .enquiry_title {
        @extend .book-title;
    }
    .el-input__inner {
        width: 100% !important;
    }
    .enquiry_main {
        width: 466px;
        background: #ffffff;
        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
        padding: 24px 22px;
        box-sizing: border-box;
        flex-wrap: wrap;
        position: relative;
        .el-form-item {
            float: none;
        }
    }

    .enquiry_main_date {
        width: 120px;
        float: left;
        margin-left: 0;
        margin-right: 27px;
    }

    .enquiry_main_date .el-input__inner {
        width: 120px;
        font-size: 17px;
        padding-top: 2px !important;
        box-sizing: border-box;
        font-weight: bold;
        color: #172a88;
    }

    .enquiry_main_date .el-date-editor.el-input {
        width: 120px;
    }
    // 手机号码
    .code-phone {
        width: 100%;
        display: flex;
        .enquiry_main_code {
            /* prettier-ignore */
            min-width: 85PX;
        }
        .enquiry_main_number {
            flex: 1;
        }
    }
    // 按钮
    .form-btn {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 80px;
        .tour_book_sub {
            width: 164px;
            height: 31px;
            @extend .book_sub;
        }
        .tour_book_close {
            width: 164px;
            height: 31px;
            @extend .book_close;
        }
    }
}
::v-deep .enquiry_main {
    .enquiry_main_number {
        .el-input__inner {
            width: 100% !important;
            margin-left: 5px;
        }
    }
    .mumber {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .enquiry_main_adults {
        width: 200px;
        float: left;
        /* margin-right: 22px; */
    }
    .enquiry_main_adults .el-input__suffix {
        top: 0px;
        display: flex;
        align-items: center;
        /* margin-right: 22px; */
    }
    .enquiry_main_child {
        margin-left: 22px;
    }
    .enquiry_main_adults .el-input__inner {
        width: 200px;
        color: #172a88;
    }

    .enquiry_main_adults .el-input__icon {
        line-height: 0;
    }
}
</style>
